module.exports = __webpack_public_path__ + "static/albums-logo-546a6eab37c90d24fb527e3d502a3d7d.svg";